export const getRandomColor = (name: string) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 7) - hash);
  }

  const r = (hash & 0xff0000) >> 16;
  const g = (hash & 0x00ff00) >> 8;
  const b = hash & 0x0000ff;

  const color = `#${((r ^ 0x33) & 0xff).toString(16).padStart(2, '0')}${((g ^ 0x66) & 0xff).toString(16).padStart(2, '0')}${((b ^ 0x99) & 0xff).toString(16).padStart(2, '0')}`;

  return color;
};

export function getRandomColorWithOpacity(componentName: string, opacity = 1) {
  const color = getRandomColor(componentName);
  const rgbaColor = hexToRgba(color, opacity);
  return rgbaColor;
}

function hexToRgba(hex: any, opacity: number) {
  if (!hex) {
    console.error('Hex value is null or undefined.');
    return `rgba(0, 0, 0, ${opacity})`;
  }

  const hexWithoutHash = hex.replace('#', '');
  if (!/^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hexWithoutHash)) {
    console.error('Invalid hex format.');
    return `rgba(0, 0, 0, ${opacity})`;
  }

  const rgb = hexWithoutHash.match(/.{1,2}/g).map((x: string) => parseInt(x, 16));
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`;
}

export const formatToID = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/ä/g, 'ae') // Replace 'ä' with 'ae'
    .replace(/ö/g, 'oe') // Replace 'ö' with 'oe'
    .replace(/ü/g, 'ue') // Replace 'ü' with 'ue'
    .replace(/ß/g, 'ss') // Replace 'ß' with 'ss'
    .replace(/[^a-z0-9]/g, '-') // Replace non-alphanumeric characters with hyphens
    .replace(/-+/g, '-') // Reduce multiple consecutive hyphens to a single hyphen
    .replace(/^-|-$/g, ''); // Remove hyphens at the beginning and end
};
